import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useAppContext } from "../../../2_ksbHub/context/appContext";
import { useSondertagContext } from "../context/sondertagContext";
import useSondertagStats from "./useSondertagStats";
import { useMemo } from "react";

function useViewOptions() {
  const theme = useTheme();

  const { isATeacher, currentUser } = useAppContext();

  const { angebote, isASondertageEventAdmin } = useSondertagContext();

  const { mySlotsCount, freeSlots, totalSlots } = useSondertagStats(
    angebote,
    currentUser,
  );

  const leerSlots = useMemo(
    () =>
      angebote.filter((a) => {
        if (!a.owners?.length) return false;

        return (
          a.owners.length === 1 &&
          a.owners[0]?.abbreviation?.toLowerCase() === "leer"
        );
      }).length,
    [angebote],
  );

  return useMemo(
    () => [
      {
        id: "all",
        label: "Alle",
      },

      {
        id: "mine",
        label: (
          <Box sx={{ display: "flex", gap: 0.5 }}>
            Meine
            <Box
              component="span"
              sx={{
                fontWeight: 600,
              }}
            >
              ({mySlotsCount})
            </Box>
          </Box>
        ),
      },

      {
        id: "leer",
        label: (
          <Box sx={{ display: "flex", gap: 0.5 }}>
            Leer
            <Box
              component="span"
              sx={{
                color: theme.palette.warning.main,
                fontWeight: 600,
              }}
            >
              ({leerSlots})
            </Box>
          </Box>
        ),
      },

      ...(isATeacher || isASondertageEventAdmin
        ? [
            {
              id: "leitung",
              label: (
                <Box sx={{ display: "flex", gap: 0.5 }}>
                  {"Offen"}

                  {totalSlots > 0 && (
                    <Box
                      component="span"
                      sx={{
                        color: theme.palette.warning.main,
                        fontWeight: 600,
                      }}
                    >
                      ({freeSlots})
                    </Box>
                  )}
                </Box>
              ),
            },
          ]
        : []),
    ],
    [
      mySlotsCount,
      leerSlots,
      freeSlots,
      totalSlots,
      isATeacher,
      isASondertageEventAdmin,

      theme,
    ],
  );
}

export default useViewOptions;
